var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 19,
    viewBox: "0 0 25 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7791_10207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2501 2H2.75012C1.92169 2 1.25012 2.67157 1.25012 3.5V15.5C1.25012 16.3284 1.92169 17 2.75012 17H22.2501C23.0785 17 23.7501 16.3284 23.7501 15.5V3.5C23.7501 2.67157 23.0785 2 22.2501 2Z",
    stroke: "#6921C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2 11.344C11.4166 11.6284 11.6985 11.8565 12.022 12.0088C12.3454 12.1611 12.7008 12.2332 13.058 12.219C14.197 12.219 15.121 11.526 15.121 10.672C15.121 9.818 14.2 9.126 13.062 9.126C11.924 9.126 11 8.433 11 7.578C11 6.723 11.924 6.031 13.062 6.031C13.4193 6.01652 13.7747 6.0885 14.0982 6.24084C14.4217 6.39318 14.7036 6.62136 14.92 6.906",
    stroke: "#FF6019",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.062 12.219V13.25",
    stroke: "#FF6019",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.062 5V6.031",
    stroke: "#FF6019",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.00012 6.125C4.79301 6.125 4.62512 5.95711 4.62512 5.75C4.62512 5.54289 4.79301 5.375 5.00012 5.375",
    stroke: "#FF6019",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.00012 6.125C5.20723 6.125 5.37512 5.95711 5.37512 5.75C5.37512 5.54289 5.20723 5.375 5.00012 5.375",
    stroke: "#FF6019",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 13.625C19.793 13.625 19.6251 13.4571 19.6251 13.25C19.6251 13.0429 19.793 12.875 20.0001 12.875",
    stroke: "#FF6019",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 13.625C20.2072 13.625 20.3751 13.4571 20.3751 13.25C20.3751 13.0429 20.2072 12.875 20.0001 12.875",
    stroke: "#FF6019",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7791_10207"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.500122 -2.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/Cash.3769ab5c.svg";
export { ForwardRef as ReactComponent };